import { useState } from "react";
import { MapPin, CreditCard, User, Plus, Trash2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TopBar } from "@/components/Shell";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { MageCityLogo } from "@/components/Brand";import { toast } from "sonner";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [addresses, setAddresses] = useState(user?.addresses || []);
  const [newAddr, setNewAddr] = useState("");

  const save = async (extra = {}) => {
    try {
      await api.put("/auth/profile", { name, phone, addresses, ...extra });
      await refresh();
      toast.success("Perfil atualizado!");
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    }
  };

  const addAddress = () => {
    if (!newAddr.trim()) return;
    const next = [...addresses, { label: `Endereço ${addresses.length + 1}`, value: newAddr }];
    setAddresses(next);
    setNewAddr("");
    save({ addresses: next });
  };

  const removeAddress = (i) => {
    const next = addresses.filter((_, k) => k !== i);
    setAddresses(next);
    save({ addresses: next });
  };

  return (
    <div data-testid="profile-page" className="pb-6">
      <TopBar subtitle="Meu perfil" />
      <div className="px-4 pt-5 space-y-6">
        <section>
          <h2 className="font-display font-bold flex items-center gap-2"><User size={17} className="text-gf-orange" /> Dados pessoais</h2>
          <div className="grid gap-2 mt-3">
            <Input data-testid="profile-name-input" value={name} onChange={(e) => setName(e.target.value)} className="h-12 rounded-xl" placeholder="Nome" />
            <Input data-testid="profile-phone-input" value={phone} onChange={(e) => setPhone(e.target.value)} className="h-12 rounded-xl" placeholder="Telefone" />
            <Input value={user?.email || ""} disabled className="h-12 rounded-xl bg-gf-gray" />
            <Button data-testid="profile-save-button" onClick={() => save()} className="h-12 rounded-xl gf-gradient text-white font-bold gf-press">
              Salvar alterações
            </Button>
          </div>
        </section>

        <section>
          <h2 className="font-display font-bold flex items-center gap-2"><MapPin size={17} className="text-gf-orange" /> Endereços salvos</h2>
          <div className="grid gap-2 mt-3" data-testid="addresses-list">
            {addresses.map((a, i) => (
              <div key={i} className="flex items-center gap-2 p-3 rounded-xl border border-gray-200">
                <div className="flex-1">
                  <p className="text-xs font-bold">{a.label}</p>
                  <p className="text-xs text-gray-500">{a.value}</p>
                </div>
                <button data-testid={`remove-address-${i}`} onClick={() => removeAddress(i)} className="p-2 gf-press">
                  <Trash2 size={15} className="text-mage-red" />
                </button>
              </div>
            ))}
            <div className="flex gap-2">
              <Input data-testid="new-address-input" value={newAddr} onChange={(e) => setNewAddr(e.target.value)} placeholder="Novo endereço" className="h-11 rounded-xl" />
              <Button data-testid="add-address-button" onClick={addAddress} variant="outline" className="h-11 rounded-xl">
                <Plus size={16} />
              </Button>
            </div>
          </div>
        </section>

        <section>
          <h2 className="font-display font-bold flex items-center gap-2"><CreditCard size={17} className="text-gf-orange" /> Formas de pagamento</h2>
          <div className="grid gap-2 mt-3" data-testid="payment-methods-list">
            {(user?.payment_methods || []).map((p, i) => (
              <div key={i} className="p-3 rounded-xl border border-gray-200 text-sm font-semibold">{p.label}</div>
            ))}
            {(user?.payment_methods || []).length === 0 && (
              <p className="text-xs text-gray-500">Nenhuma forma de pagamento salva.</p>
            )}
          </div>
        </section>

        <div className="pt-4 border-t border-dashed flex items-center justify-center gap-3">
          <MageCityLogo size={34} showText={false} />
          <p className="text-[10px] text-gray-400 leading-tight">
            MagéTimeFood — parceria oficial<br />Prefeitura de Magé · software Time Food
          </p>
        </div>
      </div>
    </div>
  );
}
